/**
 * Fursa Knowledge Library — Category Registry.
 *
 * The library is designed to consolidate all executive learning content
 * under a single, expandable taxonomy. Two categories are populated
 * today (person, company). The remaining nine are declared here so the
 * UI, admin tools, and backend can all agree on the vocabulary in
 * advance — this keeps the DB free of magic strings and lets us light
 * up new categories the moment content lands.
 *
 * Keep entries stable — the `key` is what lives in the DB.
 */
import {
  User, Building2, Compass, LineChart, Globe2, Award, Sparkles,
  AlertOctagon, Flame, Handshake, TrendingUp,
} from "lucide-react";

/**
 * Ordered list. `available: true` means live content exists today.
 * The UI hides `available: false` categories by default and shows
 * them behind a "قريباً" (Coming soon) group only when the admin
 * chooses to reveal the roadmap. This keeps the executive surface
 * uncluttered while broadcasting the ambition.
 */
export const KNOWLEDGE_CATEGORIES = [
  { key: "person",       label: "نجاح شخصيات",        icon: User,         available: true },
  { key: "company",      label: "نجاح شركات",          icon: Building2,    available: true },
  { key: "strategy",     label: "استراتيجيات الأعمال", icon: Compass,      available: false },
  { key: "investment",   label: "الاستثمار",           icon: LineChart,    available: false },
  { key: "economy",      label: "الاقتصاد",            icon: Globe2,       available: false },
  { key: "leadership",   label: "القيادة",             icon: Award,        available: false },
  { key: "innovation",   label: "الابتكار",            icon: Sparkles,     available: false },
  { key: "mistakes",     label: "أخطاء تاريخية",       icon: AlertOctagon, available: false },
  { key: "crises",       label: "الأزمات",             icon: Flame,        available: false },
  { key: "acquisitions", label: "عمليات الاستحواذ",    icon: Handshake,    available: false },
  { key: "markets",      label: "دروس الأسواق",        icon: TrendingUp,   available: false },
];

export const CATEGORY_LABEL = Object.fromEntries(
  KNOWLEDGE_CATEGORIES.map((c) => [c.key, c.label])
);

export const CATEGORY_ICON = Object.fromEntries(
  KNOWLEDGE_CATEGORIES.map((c) => [c.key, c.icon])
);

export const AVAILABLE_CATEGORY_KEYS = KNOWLEDGE_CATEGORIES
  .filter((c) => c.available)
  .map((c) => c.key);

export const COMING_SOON_CATEGORIES = KNOWLEDGE_CATEGORIES.filter(
  (c) => !c.available
);
